import { render, staticRenderFns } from "./ClinicChTherapyDic.vue?vue&type=template&id=416ce0e0"
import script from "./ClinicChTherapyDic.vue?vue&type=script&lang=js"
export * from "./ClinicChTherapyDic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416ce0e0')) {
      api.createRecord('416ce0e0', component.options)
    } else {
      api.reload('416ce0e0', component.options)
    }
    module.hot.accept("./ClinicChTherapyDic.vue?vue&type=template&id=416ce0e0", function () {
      api.rerender('416ce0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicChTherapyDic.vue"
export default component.exports